import React from 'react'

const AgbPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-3xl font-bold mb-8 text-center">Allgemeine Geschäftsbedingungen</h1>
        
        <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
          <div className="text-center bg-indigo-50 p-6 rounded-lg">
            <h2 className="text-2xl font-semibold mb-4 text-indigo-800">Herzlich willkommen bei PhoneMedic!</h2>
            <p className="text-gray-700">
              Diese Allgemeinen Geschäftsbedingungen enthalten die Regeln und Bestimmungen für die Nutzung der Website von PhoneMedic.
            </p>
          </div>
          
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
            <p className="text-gray-800">
              <strong>Wichtiger Hinweis:</strong> Wir gehen davon aus, dass Sie bei Aufruf der Website die Allgemeinen Geschäftsbedingungen 
              in vollem Umfang akzeptieren. Bitte fahren Sie mit der Nutzung von PhoneMedic nicht fort, sofern Sie nicht mit allen 
              auf dieser Seite aufgeführten Bedingungen einverstanden sind.
            </p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">1. Geltungsbereich</h2>
            <div className="space-y-3 text-gray-700">
              <p>
                Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für alle Verträge zwischen PhoneMedic, 
                Konrad Blersch, Wahlenstraße 27, 93047 Regensburg (nachfolgend „PhoneMedic" oder „wir") und dem Kunden 
                über die Erbringung von Reparaturdienstleistungen an elektronischen Geräten.
              </p>
              <p>
                Abweichende, entgegenstehende oder ergänzende Allgemeine Geschäftsbedingungen des Kunden werden nur dann 
                und insoweit Vertragsbestandteil, als wir ihrer Geltung ausdrücklich zugestimmt haben.
              </p>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">2. Vertragsschluss</h2>
            <div className="space-y-3 text-gray-700">
              <p>
                Die Darstellung der Dienstleistungen auf unserer Website stellt kein rechtlich bindendes Angebot, 
                sondern eine unverbindliche Aufforderung dar, Dienstleistungen zu bestellen.
              </p>
              <p>
                Mit dem Absenden einer Bestellung gibt der Kunde ein verbindliches Angebot ab. Wir können dieses Angebot 
                durch eine Auftragsbestätigung per E-Mail oder durch Aufnahme der Reparaturarbeiten annehmen.
              </p>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">3. Cookies</h2>
            <div className="space-y-3 text-gray-700">
              <p>
                Die Website verwendet Cookies, um Ihr Online-Erlebnis zu personalisieren. Durch weiteren Zugriff auf 
                PhoneMedic stimmen Sie der Verwendung von Cookies zu.
              </p>
              <p>
                Ein Cookie ist eine Textdatei, die von einem Webserver auf Ihrer Festplatte gespeichert wird. Cookies 
                können keine Programme ausführen oder Viren auf Ihren Computer übertragen. Sie enthalten einen eindeutigen 
                Identifikator und können nur von dem Webserver der Domain gelesen werden, die das Cookie bei Ihnen gespeichert hat.
              </p>
              <p>
                Wir verwenden Cookies zu unterschiedlichen Zwecken, unter anderem zur Analyse und für personalisierte 
                Marketingmitteilungen, mit dem Ziel, die Benutzerfreundlichkeit unserer Website zu verbessern. Sie haben 
                die Möglichkeit, optionale Cookies abzulehnen. Einige Cookies sind jedoch für die einwandfreie und 
                ordnungsgemäße Funktion unserer Website notwendig. Solche technisch notwendigen Cookies müssen immer 
                aktiviert werden und erfordern daher keine Einwilligung.
              </p>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">4. Preise und Zahlungsbedingungen</h2>
            <div className="space-y-3 text-gray-700">
              <p>
                Die angegebenen Preise sind Endpreise und enthalten die gesetzliche Mehrwertsteuer. Zusätzliche 
                Kosten wie Versandkosten werden gesondert ausgewiesen.
              </p>
              
              <div className="bg-blue-50 p-4 rounded border border-blue-200">
                <h3 className="font-semibold text-blue-800 mb-2">Verfügbare Zahlungsmethoden</h3>
                <ul className="text-sm space-y-1">
                  <li><strong>PayPal:</strong> Sichere Zahlung über PayPal Europe S.à r.l. et Cie, S.C.A.</li>
                  <li><strong>Überweisung:</strong> Traditionelle Banküberweisung nach Rechnungsstellung</li>
                </ul>
              </div>
              
              <p>
                Bei elektronischen Zahlungsverfahren erfolgt die Belastung unmittelbar nach Auftragserteilung. 
                PayPal-Zahlungen werden durch PayPal Europe S.à r.l. et Cie, S.C.A., 22-24 Boulevard Royal, 
                L-2449 Luxembourg abgewickelt.
              </p>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">5. Leistungserbringung</h2>
            <div className="space-y-3 text-gray-700">
              <p>
                PhoneMedic erbringt Reparaturdienstleistungen an elektronischen Geräten. Der Umfang der Leistung ergibt 
                sich aus der jeweiligen Leistungsbeschreibung und Auftragsbestätigung.
              </p>
              <p>
                Wir sind berechtigt, Teilleistungen zu erbringen, soweit dies für den Kunden zumutbar ist. 
                Angegebene Lieferzeiten sind unverbindlich, es sei denn, eine feste Lieferzeit ist ausdrücklich 
                zugesagt oder vereinbart worden.
              </p>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">6. Gewährleistung</h2>
            <div className="space-y-3 text-gray-700">
              <p>
                Es gelten die gesetzlichen Gewährleistungsbestimmungen. Ergänzend gewähren wir eine freiwillige 
                Garantie nach unseren Garantiebedingungen.
              </p>
              <p>
                Mängel sind uns unverzüglich schriftlich anzuzeigen. Bei berechtigten Mängelrügen übernehmen wir 
                die Kosten der Nacherfüllung einschließlich der erforderlichen Aufwendungen.
              </p>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">7. Haftung</h2>
            <div className="space-y-3 text-gray-700">
              <p>
                Wir haften nach den gesetzlichen Bestimmungen, soweit der Schaden auf einer vorsätzlichen oder 
                grob fahrlässigen Pflichtverletzung beruht. Bei einfacher Fahrlässigkeit haften wir nur bei 
                Verletzung einer wesentlichen Vertragspflicht und nur für den typischen, vorhersehbaren Schaden.
              </p>
              <p>
                Die Haftung für Datenverlust wird auf den typischen Wiederherstellungsaufwand beschränkt, 
                der bei regelmäßiger und gefahrentsprechender Anfertigung von Sicherungskopien eingetreten wäre.
              </p>
              <p>
                Die vorstehenden Haftungsbeschränkungen gelten nicht bei Schäden aus der Verletzung des Lebens, 
                des Körpers oder der Gesundheit.
              </p>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">8. Datenschutz</h2>
            <div className="space-y-3 text-gray-700">
              <p>
                Wir verarbeiten personenbezogene Daten des Kunden zur Vertragserfüllung und zur Wahrung berechtigter 
                Interessen. Details entnehmen Sie unserer Datenschutzerklärung.
              </p>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">9. Schlussbestimmungen</h2>
            <div className="space-y-3 text-gray-700">
              <p>
                Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
              </p>
              <p>
                Gerichtsstand für alle Streitigkeiten aus und im Zusammenhang mit diesem Vertrag ist Regensburg, 
                sofern der Kunde Vollkaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches 
                Sondervermögen ist.
              </p>
              <p>
                Sollten einzelne Bestimmungen dieser AGB unwirksam oder undurchführbar sein oder werden, 
                berührt dies nicht die Wirksamkeit der übrigen Bestimmungen.
              </p>
            </div>
          </div>
          
          <div className="border-t pt-6">
            <p className="text-sm text-gray-600">
              Stand: Januar 2025 | PhoneMedic - Konrad Blersch
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AgbPage